import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonial() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-white" data-id="element-142">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-144">
          

          <div className="bg-[#faf6ee] rounded-lg p-8 md:p-12 shadow-xl relative" data-id="element-145">
            <QuoteIcon className="absolute top-6 left-6 w-12 h-12 text-[#c9a961] opacity-20" data-id="element-146" />

            <div className="flex justify-center mb-4" data-id="element-147">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-[#c9a961] fill-current" data-id="element-148" />)}
            </div>

            <h3 className="font-serif text-2xl text-[#5d6e4f] mb-6 text-center" data-id="element-149">
              "Mi ropa me volvió a quedar"
            </h3>

            <p className="text-lg md:text-xl text-[#2d2d2d] leading-relaxed mb-6 italic" data-id="element-150">
              "Pensé que los bochornos eran parte de mi vida para siempre. Llevo
              15 días con el protocolo y ya no sudo por las noches. ¡Incluso ya
              me abrocha ese pantalón que tenía guardado!"
            </p>

            <div className="text-center" data-id="element-151">
              <p className="font-semibold text-[#5d6e4f]" data-id="element-152">
                — Leticia G., 53 años
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}